export const MESSENGER_PINNED_CONTACTS_STORAGE_KEY = 'messenger.pinnedContacts.v1';

export function readMessengerPinnedContactIds(): string[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(MESSENGER_PINNED_CONTACTS_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((id): id is string => typeof id === 'string');
  } catch {
    return [];
  }
}

export function writeMessengerPinnedContactIds(ids: string[]): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(MESSENGER_PINNED_CONTACTS_STORAGE_KEY, JSON.stringify(ids));
  } catch {
    // localStorage может быть недоступен
  }
}
